export default __webpack_public_path__ + "static/media/btsLogo.095c7191.png";